import { render, staticRenderFns } from "./TrainingPlansPromo.vue?vue&type=template&id=23665786&scoped=true&"
import script from "./TrainingPlansPromo.vue?vue&type=script&lang=js&"
export * from "./TrainingPlansPromo.vue?vue&type=script&lang=js&"
import style0 from "./TrainingPlansPromo.vue?vue&type=style&index=0&id=23665786&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23665786",
  null
  
)

export default component.exports